export enum OAuthType {
  Facebook = 1,
  Twitter = 2,
  Google = 3,
}
